import { render, staticRenderFns } from "./produk_personal.vue?vue&type=template&id=1c7e0256&"
import script from "./produk_personal.vue?vue&type=script&lang=js&"
export * from "./produk_personal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports